import { AlignmentConnectionCreationSystem } from "@inter-ikea-core/core";
import OnDragInsertSystem from "./OnDragInsertSystem";
import { DisableFrameInteractionSystem } from "./DisableFrameInteractionSystem";
export const systemsDefinitionList = {
    alignmentConnectionCreationSystem: ({ core }) => new AlignmentConnectionCreationSystem(core.services),
    onDragInsertSystem: () => new OnDragInsertSystem(),
    disableFrameInteractionSystem: () => new DisableFrameInteractionSystem(),
};
